import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { NotebookPen } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/field`;

// Worker's "what did you do today" — saved on their clock event, printed on the timesheet.
export default function WorkNotesBox({ event, compact = false, onSaved, onChange }) {
  const [notes, setNotes] = useState(event?.work_notes || '');
  const [saving, setSaving] = useState(false);
  const [dirty, setDirty] = useState(false);
  useEffect(() => { setNotes(event?.work_notes || ''); setDirty(false); }, [event?.id, event?.work_notes]);

  const save = async () => {
    setSaving(true);
    try {
      await axios.post(`${API}/work-notes`, { event_id: event?.id, notes });
      toast.success('Work notes saved — they print on the timesheet');
      setDirty(false);
      onSaved && onSaved(notes);
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not save notes'); }
    setSaving(false);
  };

  return (
    <div className={compact ? 'mt-2 pt-2 border-t border-slate-300' : 'mt-3'} data-testid={`work-notes-box-${event?.id || 'active'}`}>
      <label className={`flex items-center gap-1.5 text-xs font-medium mb-1 ${compact ? 'text-slate-800' : 'text-slate-700'}`}>
        <NotebookPen className="w-3.5 h-3.5" /> What did you work on today? <span className={`font-normal ${compact ? 'text-slate-600' : 'text-slate-500'}`}>(prints on the timesheet)</span>
      </label>
      <textarea
        value={notes}
        onChange={(e) => { setNotes(e.target.value); setDirty(true); onChange && onChange(e.target.value); }}
        rows={compact ? 2 : 3}
        placeholder="e.g. Replaced #3 conveyor bearings, aligned drive, test ran with customer"
        className="w-full px-3 py-2 rounded-lg bg-white text-slate-900 text-sm placeholder:text-slate-500 outline-none focus:ring-2 focus:ring-emerald-400"
        data-testid={`work-notes-input-${event?.id || 'active'}`}
      />
      <div className="flex items-center justify-between mt-1">
        <span className={`text-[11px] ${compact ? 'text-slate-600' : 'text-slate-500'}`}>{event?.work_notes_at ? `Saved ${new Date(event.work_notes_at).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}` : ''}</span>
        <button onClick={save} disabled={saving || !dirty}
          className="px-3 py-1 bg-emerald-600 hover:bg-emerald-700 disabled:bg-slate-300 disabled:text-slate-700 text-white rounded text-xs font-semibold"
          data-testid={`work-notes-save-${event?.id || 'active'}`}>
          {saving ? 'Saving…' : 'Save notes'}
        </button>
      </div>
    </div>
  );
}
